module.exports = __webpack_public_path__ + "img/ennetix-add-custom-app.32777b9e.png";